import { Styles } from '@typings/common';

export const dialog: Styles = {
  '& *:focus': {
    outline: 'none',
  },
};
